import { render, staticRenderFns } from "./CulvertTable.vue?vue&type=template&id=1bd60340&scoped=true&"
import script from "./CulvertTable.vue?vue&type=script&lang=ts&"
export * from "./CulvertTable.vue?vue&type=script&lang=ts&"
import style0 from "./CulvertTable.vue?vue&type=style&index=0&id=1bd60340&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd60340",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VCol,VContainer,VDataTable,VIcon,VRow,VTooltip})
